import { TableResponse } from 'components/Table/types'
import { Env } from 'config/Env'
import {
  CreateDomoDbReq,
  CreateRationaleReq,
  UpdateDomoDbReq,
  UpdateRationaleReq,
  UpdateDomoDbPriorityReq,
  CreateSourceHospitalReq,
  UpdateSourceHospital,
  ReqBody,
  MapHospitalBody,
  UnMappedHospitalReq,
  SourceHospitalByOrg,
  CreateDenialRationalReq,
  DenialRationaleUpdateReq,
} from 'features/account/types'
import {
  BranchMatchApiRequest,
  BranchMatchApiResponse,
  CommunityContactViewApi,
  CommunityLocationNoteViewApi,
  CommunityStaffAvailabilityViewApi,
  FacilityMapBoundariesApi,
  GeoEnvelope,
  ReferralFacilityListRequest,
  ReferralPatientLocationApi,
} from 'features/referrals/types/geolocation'
import { DropDownEnvelope } from 'utils/types/DropDownEnvelope'
import { Envelope } from 'utils/types/Envelope'

import { HttpClient, ApiRequestTypes } from '../../../utils/apiService/httpService'
import {
  ReferralDrugPriceRequest,
  ReferralDrugPriceResponse,
  SubmissionCommunityTotalsRequest,
  SubmissionCommunityTotalsResponse,
  ActivityLogsResponse,
  Referral,
  QuestionRequest,
  AnswerList,
  HoldReferral,
  LostReferral,
  BulkHoldRequest,
  BulkLostRequest,
  BulkCommunityReviewRequest,
  BulkActionEnvelope,
  CardResponse,
  ReferralsGidview,
  PendingPatient,
  HchbSubmitRequest,
  MarkInsuranceValidationRequest,
  ReferralApproveRejectRequest,
  SexOffenderMatchBody,
  WaystarMatchRequest,
  ParentReferralApproveReject,
  QuestionAnswer,
  OutboundMessageRequest,
  MessagesFromSourceRequest,
  TaskListRequest,
  UpdateTaskListStatus,
  UnLockReferralData,
  MappedCommunitiesRequest,
  AddMappedCommunityRequest,
  CommunitiesForUnmatchedRequest,
  SubmitClinicalReviewParentDTO,
  SubmitClinicalReviewChildDTO,
  PVerifyMatchRequest,
  PVerifySubmitObject,
  PVerifyValidateRequest,
  SavePayerNoteRequest,
  ReorderInsuranceRequest,
  AssignListResponse,
  AssignedUsersReq,
  DeleteAssignedUserReq,
  AssignedUserResponse,
  AddUsersReq,
  ActivityLogsRequest,
  ConfirmReadAlertRequest,
  InsuranceDetailReq,
  ReferralUpdatesResData,
  CommunityFaxReq,
  FaxStatusResponse,
  BoolResp,
  QuestionResponse,
  InsuranceInfo,
  ChildReferralSkipSubmitRequest,
  DeleteReferral,
  ParentCommunityListRequest,
  CommunityListForSkipRequest,
  ParentReferralDetailRequest,
  RefManualAdmitReq,
  CreateNotes,
  AllNotesList,
  EditNotes,
  BroadcastOutboundMessageRequest,
  AssignedUsers,
  EditCustomFilter,
  CreateCustomFilter,
  SetDefaultCustomFilter,
  UpdatePrimaryRationaleReq,
  AddPrimaryRationaleReq,
  DenialReasonReq,
  UpdateDenialReasonReq,
  RationaleList,
  HoldRationaleByOrgReq,
  RefPanelObject,
  DuplicaterefReq,
  ReferralCapabilityRequestPayload,
  CommunityCapabilitiesReqBody,
  AddCapabilityReferralReqBody,
  ReferralCapabilitiesData,
  MCMTriggerStatus,
  MCMFieldsUpdateRequest,
} from '../types'
import { ActivityFeedRequest, ActivityFeedResponse } from '../types/activityFeed'
import {
  AddClinicalReviewReasonRequest,
  AddClinicalReviewReasonResponse,
  ClinicalReviewVersionDetailResponse,
  ClinicalReviewVersionFileResponse,
  ClinicalReviewVersionsRequest,
  ClinicalReviewVersionsResponse,
  UserNameByEmailResponse,
} from '../types/clinicalReviewVersion'

import { getActivityFeedFixture, USE_ACTIVITY_FEED_FIXTURE } from './activityFeed.fixture'
import {
  getClinicalReviewVersionsFixture,
  USE_CLINICAL_REVIEW_VERSION_FIXTURE,
} from './clinicalReviewVersion.fixture'

const TASK_LIST_URL = `${Env.REACT_APP_API_URL}Referral/api/TaskList`
const UPDATE_TASK_LIST_URL = `${Env.REACT_APP_API_URL}Referral/api/TaskList/UpdateTaskListStatus`

const IMPORT_REFERRAL_URL = `${Env.REACT_APP_API_URL}Referral/api/Referral/ImportReferral`
const ACTIVITY_LOG_URL = `${Env.REACT_APP_API_URL}Referral/api/Referral/GetActivityLog`
const SAVE_NEW_PARENT_CHILD_REFERRAL = `${Env.REACT_APP_API_URL}Referral/api/Referral/CreateReferral`
const UPDATE_CHILD_REFERRAL = `${Env.REACT_APP_API_URL}Referral/api/Referral/UpdateChildReferral`
const UPDATE_PARENT_REFERRAL = `${Env.REACT_APP_API_URL}Referral/api/ParentReferral/UpdateParentReferral`
const GET_CHILD_REFERRAL_DETAIL_URL = `${Env.REACT_APP_API_URL}Referral/api/Referral/GetReferralById`
const GET_PARENT_REFERRAL_DETAIL_URL = `${Env.REACT_APP_API_URL}Referral/api/ParentReferral/GetParentReferralById`
const SAVE_ATTACHMENTS_URL = `${Env.REACT_APP_API_URL}Referral/api/Referral/saveattachment`
const GET_REFERRAL_SOURCE_PDF_URL = `${Env.REACT_APP_API_URL}Referral/api/Referral/GetDocumentById`
const GET_ATTACHMENT_DOC_URL = `${Env.REACT_APP_API_URL}Referral/api/Referral/GetAttachmentDocumentById`
const GET_QUESTION_VIEW_URL = `${Env.REACT_APP_API_URL}Organization/api/FacilityCategory/GetCategoryDetailsById`
const SUBMIT_QUESTION_ANSWER_URL = `${Env.REACT_APP_API_URL}Organization/api/Answer/create`
const GET_QUESTION_ANSWER_URL = `${Env.REACT_APP_API_URL}Organization/api/Answer/GetQuestionAnswerById`
const HOLD_REFERRAL_URL = `${Env.REACT_APP_API_URL}Referral/api/Referral/HoldReferral`
const LOST_REFERRAL_URL = `${Env.REACT_APP_API_URL}Referral/api/Referral/LostReferral`
// Bulk actions at patient referral level (US-14895).
const BULK_HOLD_REFERRAL_URL = `${Env.REACT_APP_API_URL}Referral/api/Referral/BulkHoldReferral`
const BULK_LOST_REFERRAL_URL = `${Env.REACT_APP_API_URL}Referral/api/Referral/BulkLostReferral`
const BULK_COMMUNITY_REVIEW_URL = `${Env.REACT_APP_API_URL}Referral/api/Referral/BulkCommunityReview`
const REFERRAL_GRID_URL = `${Env.REACT_APP_API_URL}Referral/api/Referral/GetGroupStatus`
const REFERRAL_LIST = `${Env.REACT_APP_API_URL}Referral/api/Referral/GetAllReferrals`
const DELETE_REFERRAL_URL = `${Env.REACT_APP_API_URL}Referral/api/Referral/DeleteReferral`
const DELETE_PARENT_REFERRAL_URL = `${Env.REACT_APP_API_URL}Referral/api/ParentReferral/DeleteParentReferral`
const GET_PATIENT_MATCH = `${Env.REACT_APP_API_URL}Referral/api/Pcc/GetPatientMatch`
const PENDING_PATIENT_SUBMIT = `${Env.REACT_APP_API_URL}Referral/api/Pcc/PendingPatient`
const HCHB_PATIENT_REGISTRATION = `${Env.REACT_APP_API_URL}Referral/api/Hchb/PatientRegistration`
const REFERRAL_MANUAL_TRIGGERING = `${Env.REACT_APP_API_URL}Referral/api/Referral/ManualTriggerDbToPdf`
const COMMENT_LOG_URL = `${Env.REACT_APP_API_URL}Referral/api/Referral/GetStatusLog`
const SEX_OFFENDER_LIST_URL = `${Env.REACT_APP_API_URL}Referral/api/SexOffender/GetSexOffenderList`
const SEX_OFFENDER_MATCH_URL = `${Env.REACT_APP_API_URL}Referral/api/SexOffender/SexOffenderMatch`
const REFERRAL_DENIAL_REASONS = `${Env.REACT_APP_API_URL}Referral/api/DenialReason/GetDenialReasons`
const GET_PAYER_LIST_URL = `${Env.REACT_APP_API_URL}Referral/api/WayStar/GetPayerLists`
const GET_PVERIFY_PAYER_LIST_URL = `${Env.REACT_APP_API_URL}Referral/api/PVerify/GetPayerLists`
const WAYSTAR_MATCH_REQUEST_URL = `${Env.REACT_APP_API_URL}Referral/api/WayStar/SubmitPayer`
const PVERIFY_MATCH_REQUEST_URL = `${Env.REACT_APP_API_URL}Referral/api/PVerify/SubmitPayer`
const DELETE_WAYSTAR_PROVIDER_URL = `${Env.REACT_APP_API_URL}Referral/api/WayStar/DeletePayer`
const DELETE_PVERIFY_PROVIDER_URL = `${Env.REACT_APP_API_URL}Referral/api/PVerify/DeletePayer`
const SUBMIT_WAYSTAR_URL = `${Env.REACT_APP_API_URL}Referral/api/WayStar/WayStarSubmit`
const SUBMIT_PVERIFY_URL = `${Env.REACT_APP_API_URL}Referral/api/PVerify/PVerifySubmit`
const WAYSTAR_VALIDATE = `${Env.REACT_APP_API_URL}Referral/api/WayStar/ValidatePayer`
const PVERIFY_VALIDATE = `${Env.REACT_APP_API_URL}Referral/api/PVerify/ValidatePayer`
const SAVE_PAYER_NOTE_URL = `${Env.REACT_APP_API_URL}Referral/api/PVerify/SavePayerNote`
const DELETE_PAYER_NOTE_URL = `${Env.REACT_APP_API_URL}Referral/api/PVerify/DeletePayerNote`
const MARK_INSURANCE_VALIDATION = `${Env.REACT_APP_API_URL}Referral/api/PVerify/MarkInsuranceValidation`
const REORDER_INSURANCE_URL = `${Env.REACT_APP_API_URL}Referral/api/Referral/ReorderInsurance`

const CHILD_REFERRAL_STATUS_UPDATE = `${Env.REACT_APP_API_URL}Referral/api/Referral/StatusUpdateChild`
const CHILD_REFERRAL_APPROVE_REJECT = `${Env.REACT_APP_API_URL}Referral/api/Referral/ApproveRejectChild`
const PARENT_REFERRAL_STATUS_UPDATE = `${Env.REACT_APP_API_URL}Referral/api/ParentReferral/StatusUpdateParent`
const PARENT_REFERRAL_APPROVE_REJECT = `${Env.REACT_APP_API_URL}Referral/api/ParentReferral/ApproveRejectParent`
const PARENT_REFERRAL_SKIP = `${Env.REACT_APP_API_URL}Referral/api/ParentReferral/CompletReviewParent`
const CHILD_REFERRAL_SKIP = `${Env.REACT_APP_API_URL}Referral/api/Referral/CompletReviewChild`
const PARENT_REFERRAL_FACILITIES = `${Env.REACT_APP_API_URL}Referral/api/ParentReferral/GetReferralFacility`
const PARENT_REFERRAL_FACILITIES_FOR_SKIP = `${Env.REACT_APP_API_URL}Referral/api/ParentReferral/GetReferralFacilityForSkipReview`
const UPDATE_CLINICAL_REVIEW_STATUS = `${Env.REACT_APP_API_URL}Referral/api/ParentReferral/SubmitClinicalReviewParent`
const UPDATE_CLINICAL_REVIEW_STATUS_CHILD = `${Env.REACT_APP_API_URL}Referral/api/Referral/SubmitClinicalReviewChild`
const CLINICAL_REVIEW_FACILITIES = `${Env.REACT_APP_API_URL}Referral/api/ParentReferral/GetFacilityListClinicalReview`
const GET_ALL_ROUTES = `${Env.REACT_APP_API_URL}Referral/api/Route/GetRoutes`
const GET_ROUTES_FOR_REFERRAL_SOURCE = `${Env.REACT_APP_API_URL}Referral/api/Route/GetRoutesForReferralSource`
const GET_ALL_REFERRAL_STATUS = `${Env.REACT_APP_API_URL}Referral/api/Referral/GetStatus`
const INTEGRATION_FEATURES = `${Env.REACT_APP_API_URL}Referral/api/Referral/GetIntegrationFeaturesById`
const OUTBOUNDCOMMUNICATION = `${Env.REACT_APP_API_URL}Referral/api/ReferralSourceCommunication/AddOutBoundCommunication`
const MESSAGE_LIST_FROM_SOURCE = `${Env.REACT_APP_API_URL}Referral/api/ReferralSourceCommunication/GetAllReferralSourceCommunication`
const CHILD_REFERRAL_STATUS_REVERSE = `${Env.REACT_APP_API_URL}Referral/api/Referral/StatusReverseCommunity`
const REVERSE_TO_CLINICAL_REVIEW = `${Env.REACT_APP_API_URL}Referral/api/Referral/StatusRevertClinical`
const GET_PCC_PATIENT_DEATILS = `${Env.REACT_APP_API_URL}Referral/api/Pcc/GetPatientDetailsById`

const GET_MOST_RECENT_DENIAL_REASON = `${Env.REACT_APP_API_URL}Referral/api/DenialReason/GetMostRecentDenialReason`

const GET_INTEGRATION_SOURCE_STATUS = `${Env.REACT_APP_API_URL}Referral/api/Referral/GetIntegrationSourceStatus`
const GET_HOLD_REASONS = `${Env.REACT_APP_API_URL}Referral/api/HoldRationale/GetAll`
const GET_HOLD_REASONS_BY_ORG_ID = `${Env.REACT_APP_API_URL}Referral/api/HoldRationale/GetAllByOrganizationId`
const GET_LOST_REASONS = `${Env.REACT_APP_API_URL}Referral/api/LostRationale/GetAll`
const GET_LOST_REASONS_BY_ORG_ID = `${Env.REACT_APP_API_URL}Referral/api/LostRationale/GetAllByOrganizationId`

const GET_INSURANCE_DETAILS_BY_PATIENT_ID = `${Env.REACT_APP_API_URL}Referral/api/WayStar/GetInsuranceDetailsByPatientId`
const REFERRAL_UNLOCK = `${Env.REACT_APP_API_URL}Referral/api/ParentReferral/UnlockParentReferral`
const UNMAPPED_COMMUNITIES = `${Env.REACT_APP_API_URL}Referral/api/CommunityMapping/GetUnMappedCommunities`
const COMMUNITIES_UNMATCHED = `${Env.REACT_APP_API_URL}Referral/api/CommunityMapping/GetCommunityFacilityList`
const ADD_MAPPED_COMMUNITY = `${Env.REACT_APP_API_URL}Referral/api/CommunityMapping/SaveCommunityMapping`
const UPDATE_MAPPED_COMMUNITY = `${Env.REACT_APP_API_URL}Referral/api/CommunityMapping/EditCommunityMapping`
const MAPPED_COMMUNITIES = `${Env.REACT_APP_API_URL}Referral/api/CommunityMapping/GetMappedCommunities`
const ADD_HOLD_RATIONALE = `${Env.REACT_APP_API_URL}Referral/api/HoldRationale/Create`
const ADD_LOST_RATIONALE = `${Env.REACT_APP_API_URL}Referral/api/LostRationale/Create`

const UPDATE_LOST_RATIONALE = `${Env.REACT_APP_API_URL}Referral/api/LostRationale/Update`
const UPDATE_HOLD_RATIONALE = `${Env.REACT_APP_API_URL}Referral/api/HoldRationale/Update`

const DELETE_HOLD_RATIONALE = `${Env.REACT_APP_API_URL}Referral/api/HoldRationale/Delete`
const DELETE_LOST_RATIONALE = `${Env.REACT_APP_API_URL}Referral/api/LostRationale/Delete`
const REFERRAL_PDF_REGENERATION = `${Env.REACT_APP_API_URL}Referral/api/Referral/RegeneratePDF`
const ADD_DOMO_LABEL = `${Env.REACT_APP_API_URL}Referral/api/Domo/Create`

const UPDATE_DOMO_LABEL = `${Env.REACT_APP_API_URL}Referral/api/Domo/Update`

const DELETE_DOMO_LABEL = `${Env.REACT_APP_API_URL}Referral/api/Domo/Delete`
const FETCH_DOMO_DASHBOARD_LIST = `${Env.REACT_APP_API_URL}Referral/api/Domo/GetAll`
const UPDATE_DASHBOARD_PRIORITY = `${Env.REACT_APP_API_URL}Referral/api/Domo/UpdateDisplayOrder`
const GET_ALL_ORGANIZATION_DOMO = `${Env.REACT_APP_API_URL}Referral/api/Domo/getAllOrganization`
const GET_ALL_CATEGORY_DOMO = `${Env.REACT_APP_API_URL}Referral/api/Domo/getAllDashboardCategory`
const REFERRAL_ASSIGNED_USERS_LIST = `${Env.REACT_APP_API_URL}Referral/api/ReferralLeadAgent/GetAssignedReferralLeadAgents`
const DELETE_LEAD_AGENTS = `${Env.REACT_APP_API_URL}Referral/api/ReferralLeadAgent/DeleteReferralLeadAgent`
const ADD_REFERRAL_USERS = `${Env.REACT_APP_API_URL}Referral/api/ReferralLeadAgent/AssignReferralLeadAgents`
const GET_ASSIGNED_USERS_COUNT = `${Env.REACT_APP_API_URL}Referral/api/ReferralLeadAgent/GetAssignedUsersCount`
const CONFIRM_READ_ALERT = `${Env.REACT_APP_API_URL}Referral/api/Referral/ConfirmReadAlert`
const GET_REFERRAL_UPDATES = `${Env.REACT_APP_API_URL}Referral/api/ReferralSourceCommunication/GetUpdatedXmlDetails`

const CREATE_SOURCE_HOSPITAL = `${Env.REACT_APP_API_URL}Referral/api/SourceHospital/Create`
const UPDATE_SOURCE_HOSPITAL = `${Env.REACT_APP_API_URL}Referral/api/SourceHospital/Update`
const DELETE_SOURCE_HOSPITAL = `${Env.REACT_APP_API_URL}Referral/api/SourceHospital/Delete`
const GET_ALL_SOURCE_HOSPITALS = `${Env.REACT_APP_API_URL}Referral/api/SourceHospital/GetAll`
const GET_ALL_ORG_SOURCE_HOSPITALS = `${Env.REACT_APP_API_URL}Referral/api/SourceHospital/GetAllByOrganization`
const GET_UNMAPPED_SOURCE_HOSPITALS = `${Env.REACT_APP_API_URL}Referral/api/SourceHospitalMapping/GetUnmappedSourceHospitals`
const GET_MAPPED_SOURCE_HOSPITALS = `${Env.REACT_APP_API_URL}Referral/api/SourceHospitalMapping/GetMappedSourceHospitals`
const MAP_SOURCE_HOSPITAL = `${Env.REACT_APP_API_URL}Referral/api/SourceHospitalMapping/MapSourceHospital`
// Account-type lookup lives on the CRM controller (shared with the CRM module's
// fetchAccountTypes). Used by the Source Hospital Type dropdowns (15898/15899).
const GET_ACCOUNT_TYPES = `${Env.REACT_APP_API_URL}Referral/api/CrmAccount/GetAccountTypes`
const COMMUNITY_FAX = `${Env.REACT_APP_API_URL}Referral/api/Referral/HasCommunityFax`
const PARENT_FAX = `${Env.REACT_APP_API_URL}Referral/api/ParentReferral/HasParentFax`
const GET_AI_GENERATION_STATUS_FOR_QA = `${Env.REACT_APP_API_URL}Referral/api/ParentReferral/getAIGenerationStatus`
const GET_AI_STATUS_FOR_PARENT_REFERRAL_QA = `${Env.REACT_APP_API_URL}Referral/api/ParentReferral/GetAIForQAStatusByPatient`
const GET_AI_STATUS_FOR_COMMUNITY_REFERRAL_QA = `${Env.REACT_APP_API_URL}Referral/api/Referral/GetAIForQAStatusByCommunity`

const QUEUED_CHILD_REFERRAL_DETAIL = `${Env.REACT_APP_API_URL}Referral/api/Referral/GetQueuedReferralDetailById`
const QUEUED_PARENT_REFERRAL_DETAIL = `${Env.REACT_APP_API_URL}Referral/api/ParentReferral/GetQueuedParentReferralById`
const IMPORT_REFERRAL_FILE_URL = `${Env.REACT_APP_API_URL}Referral/api/ImportReferralFile/ImportReferralFile`

const UPDATE_INSURANCE = `${Env.REACT_APP_API_URL}Referral/api/Referral/UpdateInsurance`

const REFERRAL_MANUAL_ADMIT = `${Env.REACT_APP_API_URL}Referral/api/Referral/ReferralManualAdmit`
const CREATE_NOTES = `${Env.REACT_APP_API_URL}Referral/api/ReferralNotes/Create`
const GET_ALL_NOTES = `${Env.REACT_APP_API_URL}Referral/api/ReferralNotes/GetAll`
const EDIT_NOTES = `${Env.REACT_APP_API_URL}Referral/api/ReferralNotes/Edit`
const DELETE_NOTES = `${Env.REACT_APP_API_URL}Referral/api/ReferralNotes/Delete`
const GET_NOTE_BY_ID = `${Env.REACT_APP_API_URL}Referral/api/ReferralNotes/GetById`
const GET_ENGAGEMENT_TYPES_FOR_NOTES = `${Env.REACT_APP_API_URL}Referral/api/EngagementType/GetAll`
const BROADCAST_OUTBOUNDCOMMUNICATION = `${Env.REACT_APP_API_URL}Referral/api/ReferralSourceCommunication/BroadcastOutBoundCommunication`
const REFERRAL_QUEUED_UNLOCK = `${Env.REACT_APP_API_URL}Referral/api/ParentReferral/UnlockQueuedReferral`
const REFERRAL_QUEUED_LOCK = `${Env.REACT_APP_API_URL}Referral/api/ParentReferral/LockQueuedReferral`
const GET_PVERIFY_PAYER_LIST = `${Env.REACT_APP_API_URL}Referral/api/PVerify/GetMatchedPayerList`
const GET_ASSIGNED_USER_LIST = `${Env.REACT_APP_API_URL}Identity/api/User/GetAssignedUserList`
const CREATE_CUSTOM_FILTER = `${Env.REACT_APP_API_URL}Referral/api/CustomFilter/Create`
const EDIT_CUSTOM_FILTER = `${Env.REACT_APP_API_URL}Referral/api/CustomFilter/Edit`
const DELETE_CUSTOM_FILTER = `${Env.REACT_APP_API_URL}Referral/api/CustomFilter/Delete`
const GET_ALL_CUSTOM_FILTER = `${Env.REACT_APP_API_URL}Referral/api/CustomFilter/GetAllByUserId`
// CustomFilterModule: referral listings share module 1; leads use module 2. The patient-
// and community-level lists deliberately share one saved-filter pool.
export const PARENT_REFERRAL_FILTER_MODULE = 1
export const COMMUNITY_REFERRAL_FILTER_MODULE = 1
const SET_DEFAULT_CUSTOM_FILTER = `${Env.REACT_APP_API_URL}Referral/api/CustomFilter/SetDefault`
const CREATE_PRIMARY_RATIONALE = `${Env.REACT_APP_API_URL}Referral/api/DenialReasonGroup/Create`
const UPDATE_PRIMARY_RATIONALE = `${Env.REACT_APP_API_URL}Referral/api/DenialReasonGroup/Update`
const DELETE_PRIMARY_RATIONALE = `${Env.REACT_APP_API_URL}Referral/api/DenialReasonGroup/Delete`
const GET_SECONDARY_RATIONALE = `${Env.REACT_APP_API_URL}Referral/api/DenialReason/GetAll`
const CREATE_SECONDARY_RATIONALE = `${Env.REACT_APP_API_URL}Referral/api/DenialReason/Create`
const UPDATE_SECONDARY_RATIONALE = `${Env.REACT_APP_API_URL}Referral/api/DenialReason/Update`
const DELETE_SECONDARY_RATIONALE = `${Env.REACT_APP_API_URL}Referral/api/DenialReason/Delete`
const GET_SECONDARY_RATIONALE_DETAILS = `${Env.REACT_APP_API_URL}Referral/api/DenialReason/GetById`
const GET_PRIMARY_RATIONALES_BY_ORG = `${Env.REACT_APP_API_URL}Referral/api/DenialReasonGroup/GetPrimaryRationale`

const GET_REF_RATIONALES_BY_ROUTE = `${Env.REACT_APP_API_URL}Referral/api/ReferralSourceRationale/GetReferralSourceRationaleByRoute`
const GET_RATIONALE_ROUTES = `${Env.REACT_APP_API_URL}Referral/api/ReferralSourceRationale/GetReferralSourceRationaleRoutes`
const ADD_DENIAL_MANAGEMENT_RATIONALE = `${Env.REACT_APP_API_URL}Referral/api/ReferralSourceRationale/Create`
const UPDATE_DENIAL_MANAGEMENT_RATIONALE = `${Env.REACT_APP_API_URL}Referral/api/ReferralSourceRationale/Edit`
const DELETE_DENIAL_MANAGEMENT_RATIONALE = `${Env.REACT_APP_API_URL}Referral/api/ReferralSourceRationale/Delete`
const DUPLICATE_REFERRAL_LIST = `${Env.REACT_APP_API_URL}Referral/api/DuplicateReferral/GetDuplicateReferrals`

const GET_REFERRAL_SCREEN_PANELS = `${Env.REACT_APP_API_URL}Identity/api/PanelCustomization/GetScreenPanels`
const SAVE_REFERRAL_SCREEN_PANELS = `${Env.REACT_APP_API_URL}Identity/api/PanelCustomization/SavePanelCustomization`
const DELETE_REFERRAL_SCREEN_PANELS = `${Env.REACT_APP_API_URL}Identity/api/PanelCustomization/Delete`
const RULE_PAUSE_URL = `${Env.REACT_APP_API_URL}Referral/api/RuleConfiguration/PauseRule`
const RULE_DELETE_URL = `${Env.REACT_APP_API_URL}Referral/api/RuleConfiguration/DeleteRule`
const SEXOFFENDER_CHECK_TRIGGER = `${Env.REACT_APP_API_URL}Referral/api/FeatureAutomation/GetSexOffenderCheckStatus`
const INSURANCE_CHECK_TRIGGER = `${Env.REACT_APP_API_URL}Referral/api/FeatureAutomation/GetInsuranceCheckStatus`

const REFERRAL_COMMUNITY_CAPABILITIES = `${Env.REACT_APP_API_URL}Organization/api/CommunityCapability/GetAllReferralCapabilities`
const DELETE_REFERRAL_CAPABILITY = `${Env.REACT_APP_API_URL}Organization/api/CommunityCapability/DeleteReferralCapability`
const GET_COMMUNITY_CAPABILITIES = `${Env.REACT_APP_API_URL}Organization/api/CommunityCapability/GetAll`
const GET_REFERRAL_CAPABILITY_MAPPING = `${Env.REACT_APP_API_URL}Organization/api/CommunityCapability/GetReferralCapabilityMapping`
const SAVE_REFERRAL_CAPABILITIES = `${Env.REACT_APP_API_URL}Organization/api/CommunityCapability/SaveReferralCapabilities`
const GET_MCM_ADMISSION_STATUS = `${Env.REACT_APP_API_URL}Referral/api/ManagedCareMaster/GetAdmissionStatus`
const TRIGGER_MCM_ADMISSION = `${Env.REACT_APP_API_URL}Referral/api/ManagedCareMaster/PreAdmission`
const SAVE_MCM_FIELDS = `${Env.REACT_APP_API_URL}Referral/api/Referral/ReferralMcmFieldsUpdate`
const GET_FACILITIES_BY_PATIENT_ID = `${Env.REACT_APP_API_URL}Referral/api/Referral/GetFacilitiesByPatientId`

export const importReferral = (data: FormData): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](IMPORT_REFERRAL_URL, data)

export const getActivityLogs = (data: ActivityLogsRequest): Promise<ActivityLogsResponse> =>
  HttpClient[ApiRequestTypes.post](ACTIVITY_LOG_URL, data)

export const saveNewParentOrChildReferral = (data: Referral): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](SAVE_NEW_PARENT_CHILD_REFERRAL, data)
export const updateChildReferral = (data: Referral): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.put](UPDATE_CHILD_REFERRAL, data)
export const updateParentReferral = (data: Referral): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.put](UPDATE_PARENT_REFERRAL, data)

export const getChildReferralDetail = (id: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](`${GET_CHILD_REFERRAL_DETAIL_URL}?patientId=${id}`)

export const getParentReferralDetail = (data: ParentReferralDetailRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](GET_PARENT_REFERRAL_DETAIL_URL, data)

export const saveNewAttachments = (data: FormData): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](SAVE_ATTACHMENTS_URL, data)

export const getReferralSourcePdf = (
  patientId: number,
  isHighlightedPdf: boolean,
): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](GET_REFERRAL_SOURCE_PDF_URL, { patientId, isHighlightedPdf })

export const getAttachmentDoc = (id: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](`${GET_ATTACHMENT_DOC_URL}?id=${id}`)

export const getQuestionView = (data: QuestionRequest): Promise<QuestionResponse> =>
  HttpClient[ApiRequestTypes.post](GET_QUESTION_VIEW_URL, data)
export const submitQuestion = (data: AnswerList): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](SUBMIT_QUESTION_ANSWER_URL, data)

export const getQuestionAnswers = (data: QuestionAnswer): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](GET_QUESTION_ANSWER_URL, data)

export const setHoldReferral = (data: HoldReferral): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](HOLD_REFERRAL_URL, data)

export const setLostReferral = (data: LostReferral): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](LOST_REFERRAL_URL, data)

/** Partial success is expected — inspect `applied` / `skipped` on the response. */
export const setBulkHoldReferral = (data: BulkHoldRequest): Promise<BulkActionEnvelope> =>
  HttpClient[ApiRequestTypes.post](BULK_HOLD_REFERRAL_URL, data)

export const setBulkLostReferral = (data: BulkLostRequest): Promise<BulkActionEnvelope> =>
  HttpClient[ApiRequestTypes.post](BULK_LOST_REFERRAL_URL, data)

/** Submits a mixed set of community review outcomes in one call. */
export const setBulkCommunityReview = (
  data: BulkCommunityReviewRequest,
): Promise<BulkActionEnvelope> => HttpClient[ApiRequestTypes.post](BULK_COMMUNITY_REVIEW_URL, data)

export const getReferralForGridview = (permission: number[]): Promise<ReferralsGidview> =>
  HttpClient[ApiRequestTypes.post](REFERRAL_GRID_URL, permission)

export const getRefLists = (requestBody: unknown): Promise<CardResponse> =>
  HttpClient[ApiRequestTypes.post](REFERRAL_LIST, requestBody)

export const getPatientMatch = (id: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](`${GET_PATIENT_MATCH}?patientId=${id}`)

export const savePendingPatient = (data: PendingPatient): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](PENDING_PATIENT_SUBMIT, data)

export const submitReferralToHchb = (data: HchbSubmitRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](HCHB_PATIENT_REGISTRATION, data)

export const markInsuranceValidation = (data: MarkInsuranceValidationRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](MARK_INSURANCE_VALIDATION, data)

export const referralManualTriggering = (data: { patientId: number }): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](`${REFERRAL_MANUAL_TRIGGERING}?patientId=${data.patientId}`)

export const getCommentLogs = (id: number): Promise<ActivityLogsResponse> =>
  HttpClient[ApiRequestTypes.get](`${COMMENT_LOG_URL}?patientId=${id}`)

export const getSexOffenderList = (id: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](`${SEX_OFFENDER_LIST_URL}?patientId=${id}`)

export const sexOffenderMatch = (body: SexOffenderMatchBody): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](SEX_OFFENDER_MATCH_URL, body)
export const getRefDenialReasons = (id: number): Promise<ReferralsGidview> =>
  HttpClient[ApiRequestTypes.get](`${REFERRAL_DENIAL_REASONS}?organizationId=${id}`)

export const getPayerLists = (): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](GET_PAYER_LIST_URL)

export const waystarMatchRequest = (body: WaystarMatchRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](WAYSTAR_MATCH_REQUEST_URL, body)

export const waystarDelete = (body: WaystarMatchRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](DELETE_WAYSTAR_PROVIDER_URL, body)

export const wayStarSubmit = (patientId: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](`${SUBMIT_WAYSTAR_URL}?patientId=${patientId}`)

export const wayStarValidate = (body: WaystarMatchRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](WAYSTAR_VALIDATE, body)

export const deleteReferral = (body: DeleteReferral): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.put](DELETE_REFERRAL_URL, body)

export const deleteParentReferral = (body: DeleteReferral): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.put](DELETE_PARENT_REFERRAL_URL, body)

export const childReferralStatusUpdate = (
  patientId: number,
  statusId: number,
  userId?: string,
  roleId?: string,
): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](CHILD_REFERRAL_STATUS_UPDATE, {
    patientId,
    status: statusId,
    userId,
    roleId,
  })

export const sendOutBoundCommunication = (data: OutboundMessageRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](OUTBOUNDCOMMUNICATION, data)

export const childReferralApproveReject = (data: ReferralApproveRejectRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](CHILD_REFERRAL_APPROVE_REJECT, data)

export const parentReferralStatusUpdate = (data: ParentCommunityListRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](PARENT_REFERRAL_STATUS_UPDATE, data)

export const parentReferralApproveReject = (data: ParentReferralApproveReject): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](PARENT_REFERRAL_APPROVE_REJECT, data)

export const parentReferralSkip = (data: ParentReferralApproveReject): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](PARENT_REFERRAL_SKIP, data)

export const childReferralSkip = (data: ChildReferralSkipSubmitRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](CHILD_REFERRAL_SKIP, data)

export const parentReferralFacilities = (data: ParentCommunityListRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](PARENT_REFERRAL_FACILITIES, data)

export const getFacilitiesForClinicalReview = (
  data: ParentCommunityListRequest,
): Promise<Envelope> => HttpClient[ApiRequestTypes.post](CLINICAL_REVIEW_FACILITIES, data)

export const parentReferralFacilitiesForSkip = (
  data: CommunityListForSkipRequest,
): Promise<Envelope> => HttpClient[ApiRequestTypes.post](PARENT_REFERRAL_FACILITIES_FOR_SKIP, data)

export const updateClinicalReviewStatus = (
  data: SubmitClinicalReviewParentDTO,
): Promise<Envelope> => HttpClient[ApiRequestTypes.post](UPDATE_CLINICAL_REVIEW_STATUS, data)

export const updateClinicalReviewStatusChild = (
  data: SubmitClinicalReviewChildDTO,
): Promise<Envelope> => HttpClient[ApiRequestTypes.post](UPDATE_CLINICAL_REVIEW_STATUS_CHILD, data)

export const getRoutes = (): Promise<DropDownEnvelope> =>
  HttpClient[ApiRequestTypes.get](GET_ALL_ROUTES)
export const getRoutesForReferralSource = (): Promise<DropDownEnvelope> =>
  HttpClient[ApiRequestTypes.get](GET_ROUTES_FOR_REFERRAL_SOURCE)
export const getReferralStatus = (permission: number[]): Promise<DropDownEnvelope> =>
  HttpClient[ApiRequestTypes.post](GET_ALL_REFERRAL_STATUS, permission)

export const getIntegrationFeatures = (patientId: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](`${INTEGRATION_FEATURES}?patientId=${patientId}`)

export const getMessagesFromSource = (requestBody: MessagesFromSourceRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](MESSAGE_LIST_FROM_SOURCE, requestBody)

export const childReferralStatusRevise = (
  patientFacilityId: number,
  status: number,
): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](CHILD_REFERRAL_STATUS_REVERSE, {
    patientFacilityId,
    status,
  })

export const callReviseToClinicalReview = (
  patientFacilityId: number,
  status: number,
  notes: string,
): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](REVERSE_TO_CLINICAL_REVIEW, {
    patientFacilityId,
    status,
    notes,
  })

export const getTodoList = (data: TaskListRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](TASK_LIST_URL, data)

export const updateTaskListStatus = (data: UpdateTaskListStatus): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](UPDATE_TASK_LIST_URL, data)

export const getPccPatientDetails = (orgUuid: string, patientId: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](GET_PCC_PATIENT_DEATILS, { orgUuid, patientId })

export const getMostRecentDenialReason = (data: { patientFacilityId: number }): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](GET_MOST_RECENT_DENIAL_REASON, data)

export const getIntegrationSourceStatus = (refId: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](`${GET_INTEGRATION_SOURCE_STATUS}?childPatientId=${refId}`)

export const getInsuranceDetailsByPatientId = (data: InsuranceDetailReq): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](GET_INSURANCE_DETAILS_BY_PATIENT_ID, data)
export const callHoldReasons = (): Promise<DropDownEnvelope> =>
  HttpClient[ApiRequestTypes.get](GET_HOLD_REASONS)
export const callHoldReasonsByOrg = (body: HoldRationaleByOrgReq): Promise<DropDownEnvelope> =>
  HttpClient[ApiRequestTypes.post](GET_HOLD_REASONS_BY_ORG_ID, body)

export const callLostReasons = (): Promise<DropDownEnvelope> =>
  HttpClient[ApiRequestTypes.get](GET_LOST_REASONS)
export const callLostReasonsByOrg = (body: HoldRationaleByOrgReq): Promise<DropDownEnvelope> =>
  HttpClient[ApiRequestTypes.post](GET_LOST_REASONS_BY_ORG_ID, body)

export const unLockReferral = (data: UnLockReferralData): Promise<DropDownEnvelope> =>
  HttpClient[ApiRequestTypes.post](REFERRAL_UNLOCK, data)
export const getUnmappedCommunities = (data: string): Promise<DropDownEnvelope> =>
  HttpClient[ApiRequestTypes.post](`${UNMAPPED_COMMUNITIES}?sort=${data}`)

export const getMappedCommunities = (data: MappedCommunitiesRequest): Promise<DropDownEnvelope> =>
  HttpClient[ApiRequestTypes.post](MAPPED_COMMUNITIES, data)
export const addMappedCommunity = (data: AddMappedCommunityRequest): Promise<DropDownEnvelope> =>
  HttpClient[ApiRequestTypes.post](ADD_MAPPED_COMMUNITY, data)
export const updateMappedCommunity = (data: AddMappedCommunityRequest): Promise<DropDownEnvelope> =>
  HttpClient[ApiRequestTypes.post](UPDATE_MAPPED_COMMUNITY, data)
export const getCommunitiesForUnmatched = (
  data: CommunitiesForUnmatchedRequest,
): Promise<DropDownEnvelope> => HttpClient[ApiRequestTypes.post](COMMUNITIES_UNMATCHED, data)
export const addHoldRationale = (data: CreateRationaleReq): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](ADD_HOLD_RATIONALE, data)

export const deleteHoldRationale = (id: string): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.del](`${DELETE_HOLD_RATIONALE}?id=${id}`)

export const updateHoldRationale = (editholdid: UpdateRationaleReq): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.put](UPDATE_HOLD_RATIONALE, editholdid)

export const addLostRationale = (data: CreateRationaleReq): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](ADD_LOST_RATIONALE, data)

export const updateLostRationale = (editholdid: UpdateRationaleReq): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.put](UPDATE_LOST_RATIONALE, editholdid)

export const deleteLostRationale = (id: string): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.del](`${DELETE_LOST_RATIONALE}?id=${id}`)

export const referralRegeneratePDF = (data: { patientId: number }): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](`${REFERRAL_PDF_REGENERATION}?patientId=${data.patientId}`)

export const addDOMODbLabel = (data: CreateDomoDbReq): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](ADD_DOMO_LABEL, data)

export const updateDOMODbLabel = (editLabel: UpdateDomoDbReq): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.put](UPDATE_DOMO_LABEL, editLabel)

export const deleteDOMODbLabel = (id: string): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.del](`${DELETE_DOMO_LABEL}?id=${id}`)

export const getDOMODashboardList = (): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](FETCH_DOMO_DASHBOARD_LIST)
export const updateDOMODbPriority = (data: UpdateDomoDbPriorityReq): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.put](UPDATE_DASHBOARD_PRIORITY, data)
export const getAllOrganizationDomo = (): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](GET_ALL_ORGANIZATION_DOMO)
export const getAllCategoryDomo = (): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](GET_ALL_CATEGORY_DOMO)

export const getPverifyPayerLists = (): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](GET_PVERIFY_PAYER_LIST_URL)

export const pVerifyMatchRequest = (body: PVerifyMatchRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](PVERIFY_MATCH_REQUEST_URL, body)

export const pVerifySubmit = (data: PVerifySubmitObject): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](SUBMIT_PVERIFY_URL, data)

export const pVerifyValidate = (body: PVerifyValidateRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](PVERIFY_VALIDATE, body)

export const savePayerNote = (body: SavePayerNoteRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](SAVE_PAYER_NOTE_URL, body)

export const deletePayerNote = (id: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.del](`${DELETE_PAYER_NOTE_URL}?id=${id}`)

export const reorderInsurance = (body: ReorderInsuranceRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.put](REORDER_INSURANCE_URL, body)

export const pVerifyDeletePayer = (body: PVerifyMatchRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](DELETE_PVERIFY_PROVIDER_URL, body)
export const assignedUsersList = (requestBody: AssignedUsersReq): Promise<AssignListResponse> =>
  HttpClient[ApiRequestTypes.post](REFERRAL_ASSIGNED_USERS_LIST, requestBody)

export const deleteLeadAgent = (requestBody: DeleteAssignedUserReq): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](`${DELETE_LEAD_AGENTS}?id=${requestBody.id}`)

export const addReferralUsers = (data: AddUsersReq): Promise<AssignedUserResponse> =>
  HttpClient[ApiRequestTypes.post](ADD_REFERRAL_USERS, data)
export const assignedUsersCount = (data: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](`${GET_ASSIGNED_USERS_COUNT}?patientFacilityId=${data}`)

export const confirmReadAlert = (body: ConfirmReadAlertRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](CONFIRM_READ_ALERT, body)
export const fetchReferralUpdates = (requestBody: number): Promise<ReferralUpdatesResData> =>
  HttpClient[ApiRequestTypes.get](`${GET_REFERRAL_UPDATES}?id=${requestBody}`)

export const addSourceHospital = (data: CreateSourceHospitalReq): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](CREATE_SOURCE_HOSPITAL, data)

export const updateSourceHospital = (editSourceHos: UpdateSourceHospital): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.put](UPDATE_SOURCE_HOSPITAL, editSourceHos)

export const deleteSourceHospital = (id: string): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.del](`${DELETE_SOURCE_HOSPITAL}?id=${id}`)

export const getUnmappedSourceHospitals = (data: UnMappedHospitalReq): Promise<TableResponse> =>
  HttpClient[ApiRequestTypes.post](GET_UNMAPPED_SOURCE_HOSPITALS, data)

export const getMappedSourceHospitals = (data: ReqBody): Promise<TableResponse> =>
  HttpClient[ApiRequestTypes.post](GET_MAPPED_SOURCE_HOSPITALS, data)

export const mapSourceHospital = (data: MapHospitalBody): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](MAP_SOURCE_HOSPITAL, data)

export const getAllSourceHospitals = (): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](GET_ALL_SOURCE_HOSPITALS)

// TODO(BE-contract): confirm endpoint + response shape ({ id, name }[]) once the
// account-type lookup is delivered (stories 15970/15963).
export const getAccountTypes = (): Promise<DropDownEnvelope> =>
  HttpClient[ApiRequestTypes.get](GET_ACCOUNT_TYPES)

export const getCommunityFaxStatus = (data: CommunityFaxReq): Promise<FaxStatusResponse> =>
  HttpClient[ApiRequestTypes.post](COMMUNITY_FAX, data)

export const getParentFaxStatus = (data: CommunityFaxReq): Promise<FaxStatusResponse> =>
  HttpClient[ApiRequestTypes.post](PARENT_FAX, data)

export const fetchQueuedChildReferralDetail = (id: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](`${QUEUED_CHILD_REFERRAL_DETAIL}?patientFacilityId=${id}`)
export const fetchQueuedParentReferralDetail = (id: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](`${QUEUED_PARENT_REFERRAL_DETAIL}?patientId=${id}`)

export const getAIGenerationStatusForQA = (id: number): Promise<BoolResp> =>
  HttpClient[ApiRequestTypes.get](`${GET_AI_GENERATION_STATUS_FOR_QA}?patientId=${id}`)

export const getAIGenerationStatusForParentQA = (id: number): Promise<BoolResp> =>
  HttpClient[ApiRequestTypes.get](`${GET_AI_STATUS_FOR_PARENT_REFERRAL_QA}?patientId=${id}`)

export const getAIGenerationStatusForCommunityQA = (id: number): Promise<BoolResp> =>
  HttpClient[ApiRequestTypes.get](
    `${GET_AI_STATUS_FOR_COMMUNITY_REFERRAL_QA}?patientFacilityId=${id}`,
  )

export const importReferralFile = (data: FormData): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](IMPORT_REFERRAL_FILE_URL, data)

export const updateInsurance = (data: InsuranceInfo): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.put](UPDATE_INSURANCE, data)

export const manuallyAdmitRef = (data: RefManualAdmitReq): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](REFERRAL_MANUAL_ADMIT, data)

export const addNotes = (data: CreateNotes): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](CREATE_NOTES, data)

export const deleteNotes = (id: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.del](`${DELETE_NOTES}?id=${id}`)

export const editNotes = (data: EditNotes): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.put](EDIT_NOTES, data)

export const getAllNotes = (data: AllNotesList): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](GET_ALL_NOTES, data)

export const getNoteById = (id: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](`${GET_NOTE_BY_ID}?id=${id}`)

export const getEngagementTypesForNotes = (): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](`${GET_ENGAGEMENT_TYPES_FOR_NOTES}`)
export const createBroadcastOutBoundCommunication = (
  data: BroadcastOutboundMessageRequest,
): Promise<Envelope> => HttpClient[ApiRequestTypes.post](BROADCAST_OUTBOUNDCOMMUNICATION, data)
export const unLockQueuedReferral = (data: UnLockReferralData): Promise<DropDownEnvelope> =>
  HttpClient[ApiRequestTypes.post](REFERRAL_QUEUED_UNLOCK, data)
export const lockQueuedReferral = (data: number): Promise<DropDownEnvelope> =>
  HttpClient[ApiRequestTypes.post](`${REFERRAL_QUEUED_LOCK}?patientId=${data}`)
export const getAllSourceHospitalsByOrg = (data: SourceHospitalByOrg): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](GET_ALL_ORG_SOURCE_HOSPITALS, data)
export const getMatchedPayerList = (): Promise<DropDownEnvelope> =>
  HttpClient[ApiRequestTypes.get](`${GET_PVERIFY_PAYER_LIST}`)
export const getAssignedUserList = (data: AssignedUsers): Promise<DropDownEnvelope> =>
  HttpClient[ApiRequestTypes.post](`${GET_ASSIGNED_USER_LIST}`, data)

export const createCustomFilter = (data: CreateCustomFilter): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](CREATE_CUSTOM_FILTER, data)

export const editCustomFilter = (data: EditCustomFilter): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](EDIT_CUSTOM_FILTER, data)

export const deleteCustomFilter = (id: string): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.del](`${DELETE_CUSTOM_FILTER}?id=${id}`)

export const getAllCustomFilter = (
  data: string,
  filterModule: number,
  isParentList: boolean,
): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](
    `${GET_ALL_CUSTOM_FILTER}?UserId=${data}&FilterModule=${filterModule}&IsParentList=${isParentList}`,
  )

export const setDefaultCustomFilter = (data: SetDefaultCustomFilter): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](SET_DEFAULT_CUSTOM_FILTER, data)

export const addPrimaryRationale = (data: AddPrimaryRationaleReq): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](CREATE_PRIMARY_RATIONALE, data)

export const updatePrimaryRationale = (
  editSourceHos: UpdatePrimaryRationaleReq,
): Promise<Envelope> => HttpClient[ApiRequestTypes.put](UPDATE_PRIMARY_RATIONALE, editSourceHos)

export const deletePrimaryRationale = (id: string): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.del](`${DELETE_PRIMARY_RATIONALE}?id=${id}`)
export const getSecRationaleByOrg = (data: RationaleList): Promise<TableResponse> =>
  HttpClient[ApiRequestTypes.post](GET_SECONDARY_RATIONALE, data)
export const getSecRationaleDetails = (id: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](`${GET_SECONDARY_RATIONALE_DETAILS}?id=${id}`)
export const addSecondaryRationale = (data: DenialReasonReq): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](CREATE_SECONDARY_RATIONALE, data)
export const updateSecondaryRationale = (editSourceHos: UpdateDenialReasonReq): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.put](UPDATE_SECONDARY_RATIONALE, editSourceHos)
export const deleteSecondaryRationale = (id: string): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.del](`${DELETE_SECONDARY_RATIONALE}?id=${id}`)
export const getPrimaryRationalesByOrg = (data: number): Promise<DropDownEnvelope> =>
  HttpClient[ApiRequestTypes.get](`${GET_PRIMARY_RATIONALES_BY_ORG}?organizationId=${data}`)
export const getRationalesRoutes = (): Promise<DropDownEnvelope> =>
  HttpClient[ApiRequestTypes.get](GET_RATIONALE_ROUTES)
export const getReferralSourceRationaleByRoute = (
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  routeId: number | null,
): Promise<DropDownEnvelope> => HttpClient[ApiRequestTypes.get](`${GET_REF_RATIONALES_BY_ROUTE}`)

export const addDenialRationale = (data: CreateDenialRationalReq): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](ADD_DENIAL_MANAGEMENT_RATIONALE, data)

export const updateDenialRationale = (
  editDenialRationale: DenialRationaleUpdateReq,
): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.put](UPDATE_DENIAL_MANAGEMENT_RATIONALE, editDenialRationale)

export const deleteDenialRationale = (id: string): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.del](`${DELETE_DENIAL_MANAGEMENT_RATIONALE}?id=${id}`)

export const getReferralScreenPanels = (screenKey: number): Promise<DropDownEnvelope> =>
  HttpClient[ApiRequestTypes.get](`${GET_REFERRAL_SCREEN_PANELS}?screenKey=${screenKey}`)

export const saveReferralScreenPanels = (data: RefPanelObject): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](SAVE_REFERRAL_SCREEN_PANELS, data)

export const deleteReferralScreenPanels = (
  screenKey: number,
  panelKey: number,
): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.del](
    `${DELETE_REFERRAL_SCREEN_PANELS}?ScreenKey=${screenKey}&PanelKey=${panelKey}`,
  )
export const getDuplicateRefList = (data: DuplicaterefReq): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](DUPLICATE_REFERRAL_LIST, data)
export const deleteRule = (id: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.put](`${RULE_DELETE_URL}?id=${id}`)
export const pauseRule = (id: number, pauseState: boolean): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.put](`${RULE_PAUSE_URL}?id=${id}&pause=${pauseState}`)

export const getSexOffenderCheckRslt = (data: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](`${SEXOFFENDER_CHECK_TRIGGER}?PatientId=${data}`)
export const getInsuranceCheckRslt = (data: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](`${INSURANCE_CHECK_TRIGGER}?PatientId=${data}`)

export const getReferralCommunityCapability = (
  data: ReferralCapabilityRequestPayload,
): Promise<Envelope> => HttpClient[ApiRequestTypes.post](REFERRAL_COMMUNITY_CAPABILITIES, data)

export const deleteReferralCapability = (id: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.del](`${DELETE_REFERRAL_CAPABILITY}?id=${id}`)

export const getCommunityCapabilities = (data: CommunityCapabilitiesReqBody): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](GET_COMMUNITY_CAPABILITIES, data)

export const addCapabilitiesReferral = (data: AddCapabilityReferralReqBody): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](GET_REFERRAL_CAPABILITY_MAPPING, data)

export const saveReferralCapabilities = (data: ReferralCapabilitiesData): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](SAVE_REFERRAL_CAPABILITIES, data)
export const fetchManagedCareMasterAdmissionStatus = (id: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](`${GET_MCM_ADMISSION_STATUS}?patientFacilityId=${id}`)

export const triggerManagedCareMaster = (data: MCMTriggerStatus): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](TRIGGER_MCM_ADMISSION, data)

export const updateReferralMcmFields = (data: MCMFieldsUpdateRequest): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.post](SAVE_MCM_FIELDS, data)

export const getFacilitiesByPatientId = (patientId: number): Promise<Envelope> =>
  HttpClient[ApiRequestTypes.get](`${GET_FACILITIES_BY_PATIENT_ID}?patientId=${patientId}`)

// Geomapping (#16165/#16173). Organization.Api Geo endpoints.
const GEO_BRANCH_MATCH_URL = `${Env.REACT_APP_API_URL}Organization/api/Geo/branch-match`
const GEO_FACILITIES_MAP_BOUNDARIES_URL = `${Env.REACT_APP_API_URL}Organization/api/Geo/facilities/map-boundaries`
const REFERRAL_PATIENT_LOCATION_URL = `${Env.REACT_APP_API_URL}Referral/api/referrals`

/**
 * Fetch the patient's geocoded location + org for a referral. The result feeds
 * the branch-match request. 404 when the referral has no resolvable org.
 * @param referralId the referral identifier (patient id).
 */
export const getPatientLocation = (
  referralId: number,
): Promise<{ data: ReferralPatientLocationApi }> =>
  HttpClient[ApiRequestTypes.get](
    `${REFERRAL_PATIENT_LOCATION_URL}/${referralId}/geo/patient-location`,
  )

/**
 * Fetch branch matches for a referral (list + per-branch detail data).
 * @param data org id, patient lat/long, optional zip + referral id.
 */
export const getBranchMatches = (
  data: BranchMatchApiRequest,
): Promise<{ data: BranchMatchApiResponse }> =>
  HttpClient[ApiRequestTypes.post](GEO_BRANCH_MATCH_URL, data)

/**
 * Fetch map coordinates + coverage GeoJSON for multiple facilities in one call
 * (batch). Replaces N per-facility calls and avoids the backend EF-core
 * concurrency error. Response is enveloped — read `res.data.data`.
 * @param facilityIds the community/branch ids to plot.
 */
export const getFacilitiesMapBoundaries = (
  facilityIds: number[],
): Promise<GeoEnvelope<FacilityMapBoundariesApi[]>> =>
  HttpClient[ApiRequestTypes.post](GEO_FACILITIES_MAP_BOUNDARIES_URL, facilityIds)

const GEO_REFERRAL_CONTACTS_URL = `${Env.REACT_APP_API_URL}Organization/api/CommunityContact/GetReferralContacts`
const GEO_REFERRAL_NOTES_URL = `${Env.REACT_APP_API_URL}Organization/api/CommunityLocationNote/GetReferralNotes`
const GEO_REFERRAL_STAFF_URL = `${Env.REACT_APP_API_URL}Organization/api/CommunityStaffAvailability/GetReferralStaffAvailability`

/**
 * Fetch staff availability for the given facilities (per-referral batch). Branch
 * match returns staffAvailable=0, so the real count comes from here (totalCount).
 * @param data parent referral id + facility id list.
 */
export const getReferralStaffAvailability = (
  data: ReferralFacilityListRequest,
): Promise<GeoEnvelope<CommunityStaffAvailabilityViewApi[]>> =>
  HttpClient[ApiRequestTypes.post](GEO_REFERRAL_STAFF_URL, data)

/**
 * Fetch contacts for the given facilities (per-referral batch).
 * @param data parent referral id + facility id list.
 */
export const getReferralContacts = (
  data: ReferralFacilityListRequest,
): Promise<GeoEnvelope<CommunityContactViewApi[]>> =>
  HttpClient[ApiRequestTypes.post](GEO_REFERRAL_CONTACTS_URL, data)

/**
 * Fetch general-location notes for the given facilities (per-referral batch).
 * @param data parent referral id + facility id list.
 */
export const getReferralNotes = (
  data: ReferralFacilityListRequest,
): Promise<GeoEnvelope<CommunityLocationNoteViewApi[]>> =>
  HttpClient[ApiRequestTypes.post](GEO_REFERRAL_NOTES_URL, data)

// Drug Price — Clinical Submission (US 16793), Organization module
const GET_REFERRAL_DRUG_PRICES_URL = `${Env.REACT_APP_API_URL}Organization/api/ReferralDrugPrice/GetReferralDrugPrices`
const GET_SUBMISSION_COMMUNITY_TOTALS_URL = `${Env.REACT_APP_API_URL}Organization/api/ReferralDrugPrice/GetSubmissionCommunityTotals`

/** Drug price table for the read-only Drug Price tab, for a scope + source. */
export const getReferralDrugPrices = (
  data: ReferralDrugPriceRequest,
): Promise<ReferralDrugPriceResponse> =>
  HttpClient[ApiRequestTypes.post](GET_REFERRAL_DRUG_PRICES_URL, data)

/** Per-community total price/day + high-cost flag for the submission cards. */
export const getSubmissionCommunityTotals = (
  data: SubmissionCommunityTotalsRequest,
): Promise<SubmissionCommunityTotalsResponse> =>
  HttpClient[ApiRequestTypes.post](GET_SUBMISSION_COMMUNITY_TOTALS_URL, data)

// Updates tab activity feed — Notification Rework (US 18295-18302).
const ACTIVITY_FEED_URL = `${Env.REACT_APP_API_URL}Referral/api/ActivityFeed/GetFeed`

/**
 * One page of the unified Updates feed for a referral.
 *
 * No user id or facility list is sent — the backend derives both from the token
 * (LLD §7.8), unlike the legacy notification endpoint.
 * @param data patient/community scope, category filter and cursor.
 */
export const getActivityFeed = (data: ActivityFeedRequest): Promise<ActivityFeedResponse> =>
  USE_ACTIVITY_FEED_FIXTURE
    ? getActivityFeedFixture(data)
    : HttpClient[ApiRequestTypes.post](ACTIVITY_FEED_URL, data)

// Clinical Review version history (US 18610) — Organization API, added in PR 9375.
const CLINICAL_REVIEW_VERSIONS_URL = `${Env.REACT_APP_API_URL}Organization/api/ClinicalReviewVersionHistory/GetAll`
const CLINICAL_REVIEW_VERSION_FILE_URL = `${Env.REACT_APP_API_URL}Organization/api/ClinicalReviewVersionHistory/GetFileUrlById`
const CLINICAL_REVIEW_VERSION_BY_ID_URL = `${Env.REACT_APP_API_URL}Organization/api/ClinicalReviewVersionHistory/GetById`

/**
 * Submitted versions of a referral's clinical review, newest first.
 * @param body the parent referral plus a page big enough to hold its whole history.
 */
export const getClinicalReviewVersions = (
  body: ClinicalReviewVersionsRequest,
): Promise<ClinicalReviewVersionsResponse> =>
  USE_CLINICAL_REVIEW_VERSION_FIXTURE
    ? getClinicalReviewVersionsFixture()
    : HttpClient[ApiRequestTypes.post](CLINICAL_REVIEW_VERSIONS_URL, body)

/**
 * Time-limited SAS url for one version's stored PDF.
 *
 * Always hits the real API: a url is only useful if it resolves, so there is nothing for
 * the fixture to stand in with.
 * @param id the version row's id.
 */
export const getClinicalReviewVersionFileUrl = (
  id: number,
): Promise<ClinicalReviewVersionFileResponse> =>
  HttpClient[ApiRequestTypes.get](`${CLINICAL_REVIEW_VERSION_FILE_URL}?id=${id}`)

/**
 * One version's captured answers — what "View" renders read-only.
 *
 * The snapshot lives in the version row, so this is the content of the review as it was
 * submitted rather than the referral's current answers.
 * @param id the version row's id.
 */
export const getClinicalReviewVersionDetail = (
  id: number,
): Promise<ClinicalReviewVersionDetailResponse> =>
  HttpClient[ApiRequestTypes.get](`${CLINICAL_REVIEW_VERSION_BY_ID_URL}?id=${id}`)

const CLINICAL_REVIEW_VERSION_REASON_URL = `${Env.REACT_APP_API_URL}Organization/api/ClinicalReviewVersionHistory/AddReason`
const USER_NAME_BY_EMAIL_URL = `${Env.REACT_APP_API_URL}Identity/api/User/GetUserNameByUserMail`

/**
 * Records why a clinical review was reworked, against the patient's newest version.
 *
 * The backend picks the row itself — the latest for the patient — so this must run after
 * the resubmission that created that version, never before it.
 * @param data the parent referral and the reason text.
 */
export const addClinicalReviewVersionReason = (
  data: AddClinicalReviewReasonRequest,
): Promise<AddClinicalReviewReasonResponse> =>
  HttpClient[ApiRequestTypes.post](CLINICAL_REVIEW_VERSION_REASON_URL, data)

/**
 * First and last name for the email a clinical review version stores as its author.
 * @param email the stored `createdUser`; encoded, since it travels in the query string.
 */
export const getUserNameByEmail = (email: string): Promise<UserNameByEmailResponse> =>
  HttpClient[ApiRequestTypes.get](`${USER_NAME_BY_EMAIL_URL}?userMail=${encodeURIComponent(email)}`)
